import { useState } from "react";
import { api, fmtErr } from "@/lib/api";
import { toast } from "sonner";
import { FileText, Loader2, Save } from "lucide-react";

const FIELDS = [
  { key: "job_type", label: "Job type", hint: "Full Time or Contract" },
  { key: "salary_band", label: "Salary band", hint: "Min – max compensation" },
  { key: "notice_period", label: "Max notice period", hint: "Days the role can wait" },
  { key: "must_haves", label: "Must-have skills", hint: "Required skills list" },
];
const DEFAULTS = { job_type: true, salary_band: true, notice_period: true, must_haves: true };

export default function ReportFieldsCard({ tenant, onSaved }) {
  const [fields, setFields] = useState({ ...DEFAULTS, ...(tenant?.report_fields || {}) });
  const [saving, setSaving] = useState(false);
  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/tenant/me", { report_fields: fields });
      onSaved(data);
      toast.success("Report settings saved");
    } catch (err) { toast.error(fmtErr(err.response?.data?.detail)); }
    finally { setSaving(false); }
  };
  return (
    <div className="tp-card p-6 mb-6" data-testid="report-fields-card">
      <div className="flex items-center gap-2 mb-1">
        <FileText className="w-4 h-4 text-indigo-500" />
        <div className="font-display font-semibold">Candidate Report Details</div>
      </div>
      <p className="text-sm text-slate-500 mb-4">Choose which job details appear in the Role &amp; Job section of every candidate PDF report.</p>
      <div className="grid sm:grid-cols-2 gap-2">
        {FIELDS.map((f) => (
          <label key={f.key} className="flex items-start gap-3 p-3 rounded-lg border border-[color:var(--bd-sub)] cursor-pointer hover:bg-slate-50 transition-colors">
            <input type="checkbox" className="mt-1 accent-indigo-600" data-testid={`report-field-${f.key}`}
              checked={!!fields[f.key]} onChange={(e) => setFields((s) => ({ ...s, [f.key]: e.target.checked }))} />
            <span><span className="block text-sm font-medium">{f.label}</span><span className="block text-xs text-slate-500">{f.hint}</span></span>
          </label>
        ))}
      </div>
      <button data-testid="save-report-fields" onClick={save} disabled={saving} className="mt-5 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-indigo-600 hover:bg-indigo-500 text-white disabled:opacity-60">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Save report settings
      </button>
    </div>
  );
}
